<template>
  <div id="login">
    <div class="login-page">
      <div v-if="errors.length>0">
        <ul id="errors" class="alert alert-danger">
          <li v-for="(error,index) in errors" :key="index">{{error[0]}}</li>
        </ul>
      </div>
      <h1
        style="font-size: 16px;margin: 0px;padding: 10px;color: #0056b3;"
      >{{ $t("message.login_form") }}</h1>
      <div class="form" id="logForm">
        <img src="../../assets/logo.png" style="width: 225px;margin: 0px 0px 20px 0px;">
        <form id="logForm" class="login-form" @submit="login" method="post">
          <input v-model="user.email" type="text" name="email" :placeholder="$t('message.email')">
          <input
            v-model="user.password"
            type="password"
            name="password"
            :placeholder="$t('message.pass')"
          >
          <p>* - {{$t('message.required')}}</p>
          <button><div v-if="spinner" class="spinnerek"></div><span v-if="!spinner">{{$t('message.login')}}</span></button>
          <!--<input type="submit" class="btn btn-primary" value="Zaloguj">-->
          <p class="message">
            <router-link to="/signup" class="btn btn-link">{{ $t("message.register") }}</router-link>
            <router-link to="/remember" class="btn btn-link">{{ $t("message.lost_pass") }}</router-link>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
//import router from "../../router";
import axios from "axios";
import Loader from "../Loader.vue";

export default {
  name: "Login",
  data() {
    return {
      user: {
        email: null,
        password: null
      },
      loading: false,
      userLog: false,
      spinner: false,
      errors: []
    };
  },
  components: { Loader },
  computed: {

     ...mapState(['version'])
    /*
    users() {
      return this.$store.getters["users/users"];
    }
    */
  },
  methods: {
    login: function(e) {
      this.spinner = true;
      e.preventDefault();
      const self = this;
      let lang = this.$i18n.locale;
      let trans = this.$i18n.messages[lang].message;

      axios
        .post(process.env.VUE_APP_ROOT_API + "auth/login", {
          //.post("https://app.pulsar.pl/api/auth/login", {
          email: this.user.email,
          password: this.user.password,
          lang: lang
        })
        .then(function(response) {
          //console.log(response);

          if (response.data.token) {
            self.spinner = false;
            console.log("logowanie zakończone sukcesem");
            sessionStorage.setItem("userLog", JSON.stringify(response.data));
            //this.userLog = false;

            if(self.version.version.serwis == 1){
              console.log("ServicePage");
              self.$router.push({ name: "ServicePage" });
            }else{
              self.$router.push({ name: "ContentPage" });
              console.log("ContentPage");
            }
            //window.location.replace("/test_login");
          } else if (response.data.status == false) {
            self.spinner = false;
            console.log(trans["accessDenied"]);
            self.errors = [];
            self.errors.push([trans["accessDenied"]]);
            console.log("błędne dane");
            //alert("Login incorrect");
          } else {
            self.spinner = false;
            console.log("validacja");
            self.errors = [];
            for (let err of Object.values(response.data)) {
              //self.errors.push += err + " ";
              self.errors.push(err);
            }
            //alert(self.errors);
            //console.log(self.errors);
          }
        })
        .catch(function(error) {
          console.log(error);
          alert("Problem z połączeniem.");
        });
    }
  },
  mounted() {
    /*
    axios
      .get("http://127.0.0.1:8081/api/users")
      .then(response => {
        this.info = response.data;
      })
      .catch(error => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
      */
  },
  created() {
    console.log("created()");
    this.$store.dispatch("version/load_version");
    //this.$router.push({ name: "RegisterPage" });
    //let userLog = sessionStorage.getItem("log_user");
    //if (userLog) {
    //}
    //this.debouncedBcrypt = debounce(this.setBcryptHash, this.debounceTimer);
    //console.log(this.debouncedBcrypt);
    /*
    try {
      //this.$store.dispatch("app/reset");
      //this.$store.dispatch("users/load_users");
      this.$store.dispatch("users/load_users").then(response => {
        this.db_users = response;
        this.loading = false;
      });
    } catch (err) {
      console.error(err);
    }
    */
  }
};
</script>

<style scoped>
/*
#login {
  width: 500px;
  margin: 0 auto;
  padding: 23px;
  background: #ddd;
  border-radius: 10px;
  box-shadow: 5px 5px;
}
*/
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

div.form p {
  font-size: 14px;
  text-align: left;
  color: #999;
}

#errors {
  font-size: 14px;
  list-style: disclosure-closed;
  list-style-position: outside;
  margin: 0px;
  padding: 10px;
  list-style-position: inside;
}
#errors li {
  padding: 0px;
}

.login-page {
  width: 360px;
  padding: 0px;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #23497f;
  height: 35px;
  width: 100%;
  border: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #0056b3;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #23497f;
  text-decoration: none;
  float: left;
  font-size: 14px;
}
.form .message a:hover {
  color: #0056b3;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before,
.container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #ef3b3a;
}



.spinnerek {
color: #ffffff;
font-size: 4px;
margin: 0px auto;
width: 1em !important;
height: 1em;
border-radius: 50%;
position: relative;
text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue